import React from "react";

export default function LadderView({ frame }) {
  if (!frame) return null;

  const ladder   = frame.ladder || [];
  const ltp      = frame.stock_ltp || 0;
  const callStrk = frame.positions?.options?.[0]?.strike;

  if (!ladder.length && !ltp) {
    return <div style={empty}>No ladder data</div>;
  }

  const levels = [];
  if (callStrk) levels.push({ price: callStrk, type: "call" });
  ladder.forEach((step, i) => {
    const price = step.buy_price ?? step.price;
    const qty   = step.qty ?? step.quantity ?? step.qty_to_buy;
    levels.push({ price, type: step.triggered ? "triggered" : "step", stepNum: step.step ?? i + 1, qty, triggered: !!step.triggered });
  });
  if (ltp) levels.push({ price: ltp, type: "ltp" });

  levels.sort((a, b) => b.price - a.price);

  return (
    <div style={{ maxHeight: 220, overflowY: "auto" }}>
      {levels.map((lvl, i) => (
        <div key={i} style={row}>
          <div style={{ ...dot, ...dotColors[lvl.type] || dotColors.step }} />
          <div style={{ flex: 1, fontSize: 12 }}>
            {lvl.type === "ltp" ? (
              <span style={{ fontWeight: 700, color: "#3b82f6" }}>
                LTP ${Number(ltp).toFixed(2)}
              </span>
            ) : lvl.type === "call" ? (
              <span style={{ color: "#6f42c1" }}>📞 Call ${lvl.price}</span>
            ) : (
              <span style={{ color: lvl.triggered ? "#28a745" : "#888", opacity: lvl.triggered ? 1 : 0.7 }}>
                {lvl.triggered ? "✓" : "○"} ${lvl.price}
                {lvl.qty ? <span style={qtyTag}>{lvl.qty} sh</span> : null}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

const dotColors = {
  ltp:       { background: "#3b82f6", width: 10, height: 10, boxShadow: "0 0 0 2px rgba(59,130,246,0.3)" },
  call:      { background: "#6f42c1", width: 7, height: 7 },
  triggered: { background: "#28a745", width: 7, height: 7 },
  step:      { background: "#dde0e7", width: 7, height: 7 },
};
const row    = { display: "flex", alignItems: "center", gap: 8, padding: "4px 2px", borderBottom: "1px solid #f5f5f5" };
const dot    = { borderRadius: "50%", flexShrink: 0 };
const qtyTag = { marginLeft: 6, fontSize: 10, background: "#e8f4f8", color: "#0c7cba", borderRadius: 3, padding: "1px 5px" };
const empty  = { color: "#bbb", fontSize: 12, padding: "16px 0", textAlign: "center" };
